module.exports = __webpack_public_path__ + "img/title_icon.ae798f6d.svg";